/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import {
  get as _get,
  find as _find,
  includes as _includes,
  toUpper as _toUpper,
} from "lodash";
import {
  Box,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  TextField,
  Tooltip,
  Button,
} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmptyRounded";

import useStyles from "./ContractsList.styles";
import { connect, useDispatch, useSelector } from "react-redux";
import { createStructuredSelector } from "reselect";

import { downloadCSVReport } from "../../helpers/services/ContractServices";
import NoTick from "../../images/icons/no-tick-new.png";
import SingleTick from "../../images/icons/single-tick-new.png";
import DoubleTick from "../../images/icons/double-tick-new.png";
import SandclockIcon from "../../images/icons/sandclock-green.png";
import EnvelopeIcon from "../../images/icons/envelope.png";
import HandshakeIcon from "../../images/icons/handshake.png";

import {
  retrieveContracts,
  selectContract,
} from "../../redux/contract/contract.actions";
import {
  selectContractsCollection,
  selectIsContractsCollectionFetching,
  brand_details,
} from "../../redux/contract/contract.selector";
import { useTranslation } from "react-i18next";

const ContractsList = ({
  history,
  isContractsCollectionFetching,
  contractsList,
  brand_details,
}) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const language = user.currentUser.language;
  const [contractSearchText, setContractSearchText] = React.useState("");
  const [brandDetails, setBrandDetails] = React.useState(brand_details);
  const classes = useStyles();
  const [contractsDisplayList, setContractsDisplayList] =
    React.useState(contractsList);
  const { t, i18n } = useTranslation();

  /*To change app to user language*/
  React.useEffect(() => {
    if (language && language !== i18n.language) {
      i18n.changeLanguage(language).catch((error) => console.error(error));
    }
  }, [i18n, language]);

  React.useEffect(() => {
    dispatch(retrieveContracts());
  }, []);

  React.useEffect(() => {
    // const brands = [
    //   "rh",
    //   "rbm",
    //   "bma",
    //   "bma24",
    //   "hag",
    //   "giroflex",
    //   "offecct",
    //   "profim",
    //   "connection",
    // ];
    // contractsList.map((c) => {
    //   let _brands = [];
    //   brands.map((b) => {
    //     // let _bo = _find(c.brands, { brand_name: b });
    //     // if (_bo)
    //     _brands.push(b);
    //   });
    //   c.brands = _brands;
    // });
    setContractsDisplayList(contractsList);
  }, [contractsList]);

  React.useEffect(() => {
    if (contractSearchText.length > 2) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      let _contractsDisplayList = [];
      contractsList.map((c) => {
        if (
          _includes(_toUpper(c.short_name), _toUpper(contractSearchText)) ||
          _includes(_toUpper(c.trader_name), _toUpper(contractSearchText)) ||
          _includes(c.customer_no, contractSearchText)
        )
          _contractsDisplayList.push(c);
      });
      setContractsDisplayList(_contractsDisplayList);
    } else {
      setContractsDisplayList(contractsList);
    }
  }, [contractSearchText, contractsList]);

  const handleContractSearchTextChange = (event) => {
    setContractSearchText(event.target.value);
  };

  const getBrandStatusIcon = (status) => {
    let iconComponent = <div></div>;
    switch (status) {
      case "initial":
        iconComponent = <img src={NoTick} className={classes.statusIcon} />;
        break;
      case "negotiated":
        iconComponent = <img src={SingleTick} className={classes.statusIcon} />;
        break;
      case "rejected":
        iconComponent = <ClearIcon className={classes.statusIcon} />;
        break;
      case "confirmed":
        iconComponent = <img src={DoubleTick} className={classes.statusIcon} />;
        break;
      default:
        iconComponent = <HourglassEmptyIcon className={classes.statusIcon} />;
    }
    return iconComponent;
  };

  const getContractStatusIcon = (status) => {
    let iconComponent = <div></div>;
    switch (status) {
      case "negotiating":
        iconComponent = (
          <img src={SandclockIcon} className={classes.contractStatusIcon} />
        );
        break;
      case "awaiting_client_sig":
        iconComponent = (
          <img src={EnvelopeIcon} className={classes.contractStatusIcon} />
        );
        break;
      case "rejected":
        iconComponent = <ClearIcon className={classes.contractStatusIcon} />;
        break;
      case "closed":
        iconComponent = (
          <img src={HandshakeIcon} className={classes.contractStatusIcon} />
        );
        break;
      default:
        iconComponent = (
          <img src={SandclockIcon} className={classes.contractStatusIcon} />
        );
    }
    return iconComponent;
  };

  const getStatusDisplayValue = (status) => {
    let _o = "";
    switch (status) {
      case "initial":
        _o = `${t("flokk_appendix.status.options.initial")}`;
        break;
      case "negotiated":
        _o = `${t("flokk_appendix.status.options.negotiated")}`;
        break;
      case "confirmed":
        _o = `${t("flokk_appendix.status.options.confirmed")}`;
        break;
      case "rejected":
        _o = `${t("flokk_appendix.status.options.rejected")}`;
        break;

      case "negotiating":
        _o = `${t("flokk_contractappendix.status.options.negotiating")}`;
        break;

      case "awaiting_client_sig":
        _o = `${t(
          "flokk_contractappendix.status.options.awaiting_client_sig",
        )}`;
        break;
      case "closed":
        _o = `${t("flokk_contractappendix.status.options.closed")}`;
        break;
      default:
        break;
    }
    return _o;
  };

  return (
    <Box>
      <div className={classes.tableTitleHeader}>
        <Typography variant="h6" className={classes.tableTitle}>
          {t("links.flokk_contractappendix")}
        </Typography>
        <div>
          <TextField
            variant="outlined"
            label={t("table.searchText")}
            value={contractSearchText}
            onChange={handleContractSearchTextChange}
          />
          {_get(user, "currentUser.role") === "CL" && (
            <Button onClick={downloadCSVReport} className={classes.button}>
              Export-Bericht
            </Button>
          )}
        </div>
      </div>
      <div>
        {isContractsCollectionFetching ? (
          <div>{t("flokk_contract.please_wait")}</div>
        ) : (
          <div>
            {contractsDisplayList.length > 0 ? (
              <Table stickyHeader aria-label="sticky table">
                <TableHead className={classes.tableHeader}>
                  <TableRow>
                    <TableCell className={classes.tableHeaderCell}>
                      {t("flokk_contractappendix.customer_no")}
                    </TableCell>
                    <TableCell className={classes.tableHeaderCell}>
                      {t("flokk_contract.trader_name")}
                    </TableCell>
                    <TableCell
                      style={{ width: "22%" }}
                      className={classes.tableHeaderCell}
                    >
                      {t("flokk_contract.contract")}
                    </TableCell>

                    <TableCell
                      style={{ width: "35%" }}
                      className={classes.tableHeaderCell}
                    >
                      {t("flokk_contractappendix.status.name")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {contractsDisplayList.map((contract) => {
                    return (
                      <TableRow
                        key={contract.id}
                        className={classes.tableRow}
                        hover
                        onClick={() => {
                          dispatch(selectContract(contract));
                          history.push("/contract/" + contract.contract_id);
                        }}
                      >
                        <TableCell className="loc-table-cell">
                          <Typography variant="overline">
                            {contract.customer_no}
                          </Typography>
                        </TableCell>
                        <TableCell className="loc-table-cell">
                          <Typography variant="overline">
                            {contract.trader_company_id_short_name}{" "}
                            {/* {contract.company_legal_form} */}
                          </Typography>
                        </TableCell>
                        <TableCell className="loc-table-cell">
                          <Typography variant="overline">
                            {contract.name == "contract_main" &&
                              t(
                                "flokk_contractappendix.name.options.contract_main",
                              ) +
                                " " +
                                contract.year}
                            {contract.name == "contract_ext" &&
                              t(
                                "flokk_contractappendix.name.options.contract_ext",
                              ) +
                                " " +
                                contract.year}
                          </Typography>
                        </TableCell>
                        {/*Contract Status Icon*/}

                        <TableCell className="loc-table-cell">
                          <div className={classes.brandStatusContainer}>
                            {contract.status != "negotiating" && (
                              <div className={classes.brandStatusElement}>
                                <Tooltip
                                  title={getStatusDisplayValue(contract.status)}
                                  placement="top"
                                  arrow
                                >
                                  <Typography
                                    className={classes.brandStatusValue}
                                  >
                                    {getContractStatusIcon(contract.status)}
                                  </Typography>
                                </Tooltip>
                              </div>
                            )}
                            {contract.status == "negotiating" &&
                              contract.brands.map((brand) => (
                                <div
                                  className={classes.brandStatusElement}
                                  key={brand.brand_id}
                                >
                                  <Typography
                                    className={classes.brandStatusLabel}
                                    variant="overline"
                                  >
                                    {/* {getBrandLogoElement(brand.brand_name)} */}
                                    {brandDetails.length > 0 &&
                                      brandDetails.map((b) => {
                                        if (brand.brand_name === b.name) {
                                          return (
                                            <img
                                              key={b.id}
                                              src={b.logo && b.logo.url}
                                              className={classes.tabLogos}
                                            />
                                          );
                                        }
                                      })}
                                  </Typography>
                                  <Tooltip
                                    title={getStatusDisplayValue(brand.status)}
                                    placement="top"
                                    arrow
                                  >
                                    <Typography
                                      className={classes.brandStatusValue}
                                    >
                                      {getBrandStatusIcon(brand.status)}
                                    </Typography>
                                  </Tooltip>
                                </div>
                              ))}
                          </div>
                          <div className={classes.brandStatusContainer}></div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            ) : (
              <div>{t("table.emptyDataSourceMessage")}</div>
            )}
          </div>
        )}
      </div>
    </Box>
  );
};

const mapStateToProps = createStructuredSelector({
  isContractsCollectionFetching: selectIsContractsCollectionFetching,
  contractsList: selectContractsCollection,
  brand_details: brand_details,
});

export default connect(mapStateToProps)(ContractsList);
